module.exports = __webpack_public_path__ + "static/media/careersbackground.81759c3b.jpg";